// src/i18n/index.ts
import i18n, { type TOptions } from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";

import en from "./en.json";
import fr from "./fr.json";
import de from "./de.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    de: { translation: de },
  },
  lng: "en", // TODO detect locale
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;

export const useTranslations = (namespace?: string) => {
  const { t } = useTranslation();

  return (key: string, options?: TOptions) =>
    t(namespace ? `${namespace}.${key}` : key, options);
};

export const useLocale = () => {
  const { i18n: i18nInstance } = useTranslation();

  return i18nInstance.language;
};
